import { STAKING_ACTION } from '../../constants/actions'
import { mergeToNewObject } from '../../util/object.helpers'
import { buildTransactionErrorMessage } from '../../util/walletConnect.helpers'

const stakingReducer = (state, { type, payload }) => {
  switch (type) {
    case STAKING_ACTION.CHANGE_STATE:
      return mergeToNewObject(
        state,
        { [payload.property]: payload.value },
        handleChangeState(payload)
      )

    case STAKING_ACTION.RESET_STATE:
      return mergeToNewObject(state, {
        loading: false,
        accountNumber: '',
        claimStakeProcessing: false,
        claimedStake: false,
        error: {}
      })

    // case STAKING_ACTION.GET_CLAIM_STATUS:
    //   return mergeToNewObject(state, {
    //     loading: true
    //   })

    // case STAKING_ACTION.GET_CLAIM_STATUS_SUCCESS:
    //   return mergeToNewObject(state, {
    //     isClaimed: payload?.vir > 0 || payload?.distributed > 0,
    //     loading: false
    //   })

    // case STAKING_ACTION.GET_CLAIM_STATUS_FAILED:
    //   return mergeToNewObject(state, {
    //     loading: false
    //   })

    case STAKING_ACTION.CLAIM_STAKE:
      return mergeToNewObject(state, {
        claimStakeProcessing: true,
        claimedStake: false,
        error: {}
      })

    case STAKING_ACTION.CLAIM_STAKE_SUCCESS:
      return mergeToNewObject(state, {
        claimStakeProcessing: false,
        error: {},
        claimedStake: true
      })

    case STAKING_ACTION.CLAIM_STAKE_FAILED:
      return mergeToNewObject(state, {
        claimStakeProcessing: false,
        claimedStake: false,
        error: {
          claimStake: buildTransactionErrorMessage()
        }
      })

    default:
      return state
  }
}

const stakingInitialState = {
  loading: false,
  // isClaimed: false,
  claimStakeProcessing: false,
  claimedStake: false,
  accountNumber: '',
  error: {}
}

const STAKING_PROFILE_DISPATCH = {
  LOADING: 'loading',
  CLAIM_STAKE_PROCESSING: 'claimStakeProcessing',
  ACCOUNT_NUMBER: 'accountNumber',
  CLAIM_STAKE: 'claimStake',
  ERROR: 'error'
}

export { stakingReducer, stakingInitialState, STAKING_PROFILE_DISPATCH }

const handleChangeState = ({ property }) => {
  if (property === STAKING_PROFILE_DISPATCH.ERROR) {
    return {
      claimStakeProcessing: false
    }
  } else if (property === STAKING_PROFILE_DISPATCH.CLAIM_STAKE_PROCESSING) {
    return {
      error: {}
    }
  }
  return {}
}
